import * as React from 'react';
import { SVGProps } from 'react';

export const StoreIcon2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2 6.5V13.1667C2 13.5203 2.14048 13.8594 2.39052 14.1095C2.64057 14.3595 2.97971 14.5 3.33333 14.5H12.6667C13.0203 14.5 13.3594 14.3595 13.6095 14.1095C13.8595 13.8594 14 13.5203 14 13.1667V6.5"
      stroke="#071114"
      strokeWidth="1.5"
    />
    <path
      d="M13.6565 2.5H10.9951L11.3285 5.83333C11.3285 5.83333 11.9951 6.5 12.9951 6.5C13.5201 6.50069 14.0272 6.30961 14.4211 5.96267C14.4628 5.92375 14.4938 5.87486 14.5113 5.82062C14.5288 5.76638 14.5322 5.70858 14.5211 5.65267L14.0505 2.83333C14.0347 2.7402 13.9865 2.65563 13.9144 2.59463C13.8423 2.53362 13.7509 2.5001 13.6565 2.5Z"
      stroke="#071114"
      strokeWidth="1.5"
    />
    <path
      d="M10.9951 2.5L11.3285 5.83333C11.3285 5.83333 10.6618 6.5 9.66178 6.5C8.66178 6.5 7.99512 5.83333 7.99512 5.83333V2.5H10.9951Z"
      stroke="#071114"
      strokeWidth="1.5"
    />
    <path
      d="M7.99544 2.5V5.83333C7.99544 5.83333 7.32878 6.5 6.32878 6.5C5.32878 6.5 4.66211 5.83333 4.66211 5.83333L4.99544 2.5H7.99544Z"
      stroke="#071114"
      strokeWidth="1.5"
    />
    <path
      d="M4.99539 2.5H2.33472C2.24005 2.49996 2.14844 2.53351 2.07617 2.59467C2.00391 2.65582 1.95567 2.74063 1.94005 2.834L1.47005 5.65333C1.4592 5.70925 1.46267 5.767 1.48016 5.8212C1.49764 5.87541 1.52857 5.92431 1.57005 5.96333C1.78872 6.15667 2.27739 6.50067 2.99539 6.50067C3.99539 6.50067 4.66205 5.834 4.66205 5.834L4.99539 2.5Z"
      stroke="#071114"
      strokeWidth="1.5"
    />
    <path
      d="M9.66683 10.5H6.3335V14.5H9.66683V10.5Z"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default StoreIcon2;
